angular.module 'zc.projects'

.config ($stateProvider) ->

  $stateProvider
  .state 'admin.projects.clearanceSet',
    url: '/clearance_set'
    abstract: true

  .state 'admin.projects.clearanceSet.show',
    url: '/{clearanceItemSetId:int}'
    views:
      'content@':
        templateUrl: '/templates/projects.clearance/clearance_set_show.html'
        controller: 'ClearanceSetShowCtrl'
        resolve:
          clearanceItemSet: ($stateParams, ClearanceItemSet) ->
            ClearanceItemSet.find
              projectId: $stateParams.projectId
              id: $stateParams.clearanceItemSetId
            .then (clearance_item_set) ->
              clearance_item_set



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.clearance/routes.coffee